import { interfaceHelper, objsSelectValuesToString, selectObjToString } from '../interface.helper'

import { getUserFullName } from '../../helpers/helpers'

import { IModelBaseModel } from '../model-base/model-base.interface'
import { ModelBaseModel } from '../model-base/model-base.model'
import { IUserDocuments } from '../users/user.interface'
import { IUserCoreInterface } from './users-core.interface'

const InitialUserDocument = {
  membershipStatus: '',
  startDate: null,
  endDate: null,
  validTill: null,
  documentFullName: '',
  documentNumber: '',
  image: '',
}

export const InitialUserDocumentAndExpiration = {
  file: '',
  validTill: '',
}

export class UserCoreModel extends ModelBaseModel<IUserCoreInterface> implements IModelBaseModel {
  public v: IUserCoreInterface['v']
  public id: IUserCoreInterface['id']

  public userSummary: IUserCoreInterface['userSummary']
  public userFirstName: IUserCoreInterface['userFirstName']
  public userLastName: IUserCoreInterface['userLastName']
  public userFullName: IUserCoreInterface['userFullName']
  public userName: IUserCoreInterface['userName']
  public userNameNGram: IUserCoreInterface['userNameNGram']
  public userEmail: IUserCoreInterface['userEmail']

  public userCategory: IUserCoreInterface['userCategory']
  public userDescription: IUserCoreInterface['userDescription']
  public userProfilePicture: IUserCoreInterface['userProfilePicture']
  public userType: IUserCoreInterface['userType']
  public userSubRoles: IUserCoreInterface['userSubRoles']
  public userDOB: IUserCoreInterface['userDOB']

  public userAmateur?: IUserCoreInterface['userAmateur']
  public userDiscipline: IUserCoreInterface['userDiscipline']

  public userNationality: IUserCoreInterface['userNationality']
  public userZone: IUserCoreInterface['userZone']
  public userAddress: IUserCoreInterface['userAddress']
  public userLong: IUserCoreInterface['userLong']
  public userLat: IUserCoreInterface['userLat']
  public userState: IUserCoreInterface['userState']
  public userLocation: IUserCoreInterface['userLocation']

  public userAccountPrivacy?: IUserCoreInterface['userAccountPrivacy']

  //English discipline numbers
  public userFEI?: IUserCoreInterface['userFEI']
  public userUSEF?: IUserCoreInterface['userUSEF']
  public userUSDF?: IUserCoreInterface['userUSDF']
  public userUSEA?: IUserCoreInterface['userUSEA']
  public userAHHS?: IUserCoreInterface['userAHHS']
  public userAMHA?: IUserCoreInterface['userAMHA']
  public userASHA?: IUserCoreInterface['userASHA']
  public userUPHA?: IUserCoreInterface['userUPHA']
  public userWDAA?: IUserCoreInterface['userWDAA']
  public userARHPA?: IUserCoreInterface['userARHPA']
  public userUSHJA?: IUserCoreInterface['userUSHJA']
  public userACPS?: IUserCoreInterface['userACPS']
  public userAHA?: IUserCoreInterface['userAHA']
  public userEVUSA?: IUserCoreInterface['userEVUSA']
  public userIALHA?: IUserCoreInterface['userIALHA']
  public userIFSHA?: IUserCoreInterface['userIFSHA']
  public userNSHR?: IUserCoreInterface['userNSHR']
  public userPFHA?: IUserCoreInterface['userPFHA']
  public userWPCSA?: IUserCoreInterface['userWPCSA']
  public userUSTA?: IUserCoreInterface['userUSTA']
  public userEC?: IUserCoreInterface['userEC']

  //Western discipline numbers
  public userARHA?: IUserCoreInterface['userARHA']
  public userAPHA?: IUserCoreInterface['userAPHA']
  public userAQHA?: IUserCoreInterface['userAQHA']
  public userBBR?: IUserCoreInterface['userBBR']
  public userIBRA?: IUserCoreInterface['userIBRA']
  public userNBHA?: IUserCoreInterface['userNBHA']
  public userNCHA?: IUserCoreInterface['userNCHA']
  public userNRCHA?: IUserCoreInterface['userNRCHA']
  public userNRHA?: IUserCoreInterface['userNRHA']
  public userNSBA?: IUserCoreInterface['userNSBA']

  //Rodeo discipline numbers
  public userAPRA?: IUserCoreInterface['userAPRA']
  public userIPRA?: IUserCoreInterface['userIPRA']
  public userPBR?: IUserCoreInterface['userPBR']
  public userPRCA?: IUserCoreInterface['userPRCA']
  public userWPRA?: IUserCoreInterface['userWPRA']

  //College discipline numbers
  public userIHSA?: IUserCoreInterface['userIHSA']
  public userNCEA?: IUserCoreInterface['userNCEA']
  public userNHSRA?: IUserCoreInterface['userNHSRA']
  public userNIRA?: IUserCoreInterface['userNIRA']
  public userNLBR?: IUserCoreInterface['userNLBR']

  public userOtherDocument?: IUserCoreInterface['userOtherDocument']
  public userExtraDocument?: IUserCoreInterface['userExtraDocument']

  public userPocDetails?: IUserCoreInterface['userPocDetails']

  public userWebsite?: IUserCoreInterface['userWebsite']
  public userTwitter?: IUserCoreInterface['userTwitter']
  public userFacebook?: IUserCoreInterface['userFacebook']
  public userInstagram?: IUserCoreInterface['userInstagram']
  public userLinkedin?: IUserCoreInterface['userLinkedin']
  public websiteUrl: IUserCoreInterface['websiteUrl']

  public userMemberships?: IUserCoreInterface['userMemberships']
  public userTeamMembers: IUserCoreInterface['userTeamMembers']

  public paymentMethodsAccess: IUserCoreInterface['paymentMethodsAccess']

  public userCreated: IUserCoreInterface['userCreated']
  public userModified: IUserCoreInterface['userModified']

  public constructor(obj?: IUserCoreInterface) {
    super()
    this.v = obj?.v ?? 1
    this.id = obj?.id ?? ''
    this.userLat = obj?.userLat ?? ''
    this.userLong = obj?.userLong ?? ''
    this.userType = obj?.userType ?? ''
    this.userState = obj?.userState ?? ''
    this.userEmail = obj?.userEmail ?? ''
    this.userAddress = obj?.userAddress ?? ''
    this.userSubRoles = obj?.userSubRoles ?? []
    this.userLastName = obj?.userLastName ?? ''
    this.userSummary = obj?.userSummary ?? ''
    this.userCategory = obj?.userCategory ?? ''
    this.userFirstName = obj?.userFirstName ?? ''
    this.userNameNGram =
      obj?.userNameNGram ?? this.calculateUsernameNGrams(obj ? getUserFullName(obj) : '')
    this.userZone = selectObjToString(obj?.userZone) ?? ''
    this.userProfilePicture = obj?.userProfilePicture ?? ''
    this.userDescription = obj?.userDescription ?? ''
    this.userAmateur = selectObjToString(obj?.userAmateur) ?? ''
    this.userDiscipline = selectObjToString(obj?.userDiscipline) ?? ''
    this.userNationality = selectObjToString(obj?.userNationality) ?? ''
    this.userDOB = interfaceHelper.getFirestoreDate(obj?.userDOB as Date, false)
    this.userFullName = obj?.userFullName || ''
    this.userName = !!obj?.userName ? (obj.userName?.toLocaleLowerCase?.() ?? obj?.userName) : ''
    this.userTeamMembers = interfaceHelper.getStructuredTeamMembersList(obj?.userTeamMembers ?? [])
    this.paymentMethodsAccess = obj?.paymentMethodsAccess || {}

    this.userAccountPrivacy = obj?.userAccountPrivacy ?? null
    this.userLocation = obj?.userLocation ?? { lat: null, lng: null }
    this.websiteUrl = obj?.websiteUrl ?? null

    this.userExtraDocument = obj?.userExtraDocument
      ? obj?.userExtraDocument.map((currDoc) => {
          return objsSelectValuesToString(currDoc)
        })
      : []

    // English discipline numbers
    this.userFEI = obj?.userFEI
      ? this.structureNumberType(obj?.userFEI, 'userFEI')
      : InitialUserDocument
    this.userASHA = obj?.userASHA
      ? this.structureNumberType(obj?.userASHA, 'userASHA')
      : InitialUserDocument
    this.userAHHS = obj?.userAHHS
      ? this.structureNumberType(obj?.userAHHS, 'userAHHS')
      : InitialUserDocument
    this.userUSEF = obj?.userUSEF
      ? this.structureNumberType(obj?.userUSEF, 'userUSEF')
      : InitialUserDocument
    this.userUSDF = obj?.userUSDF
      ? this.structureNumberType(obj?.userUSDF, 'userUSDF')
      : InitialUserDocument
    this.userAMHA = obj?.userAMHA
      ? this.structureNumberType(obj?.userAMHA, 'userAMHA')
      : InitialUserDocument
    this.userUSEA = obj?.userUSEA
      ? this.structureNumberType(obj?.userUSEA, 'userUSEA')
      : InitialUserDocument
    this.userUPHA = obj?.userUPHA
      ? this.structureNumberType(obj?.userUPHA, 'userUPHA')
      : InitialUserDocument
    this.userWDAA = obj?.userWDAA
      ? this.structureNumberType(obj?.userWDAA, 'userWDAA')
      : InitialUserDocument
    this.userUSHJA = obj?.userUSHJA
      ? this.structureNumberType(obj?.userUSHJA, 'userUSHJA')
      : InitialUserDocument
    this.userARHPA = obj?.userARHPA
      ? this.structureNumberType(obj?.userARHPA, 'userARHPA')
      : InitialUserDocument
    this.userACPS = obj?.userACPS
      ? this.structureNumberType(obj?.userACPS, 'userACPS')
      : InitialUserDocument
    this.userAHA = obj?.userAHA
      ? this.structureNumberType(obj?.userAHA, 'userAHA')
      : InitialUserDocument
    this.userEVUSA = obj?.userEVUSA
      ? this.structureNumberType(obj?.userEVUSA, 'userEVUSA')
      : InitialUserDocument
    this.userIALHA = obj?.userIALHA
      ? this.structureNumberType(obj?.userIALHA, 'userIALHA')
      : InitialUserDocument
    this.userIFSHA = obj?.userIFSHA
      ? this.structureNumberType(obj?.userIFSHA, 'userIFSHA')
      : InitialUserDocument
    this.userNSHR = obj?.userNSHR
      ? this.structureNumberType(obj?.userNSHR, 'userNSHR')
      : InitialUserDocument
    this.userPFHA = obj?.userPFHA
      ? this.structureNumberType(obj?.userPFHA, 'userPFHA')
      : InitialUserDocument
    this.userWPCSA = obj?.userWPCSA
      ? this.structureNumberType(obj?.userWPCSA, 'userWPCSA')
      : InitialUserDocument
    this.userUSTA = obj?.userUSTA
      ? this.structureNumberType(obj?.userUSTA, 'userUSTA')
      : InitialUserDocument
    this.userEC = obj?.userEC
      ? this.structureNumberType(obj?.userEC, 'userEC')
      : InitialUserDocument

    // Western discipline numbers
    this.userARHA = obj?.userARHA
      ? this.structureNumberType(obj?.userARHA, 'userARHA')
      : InitialUserDocument
    this.userAPHA = obj?.userAPHA
      ? this.structureNumberType(obj?.userAPHA, 'userAPHA')
      : InitialUserDocument
    this.userAQHA = obj?.userAQHA
      ? this.structureNumberType(obj?.userAQHA, 'userAQHA')
      : InitialUserDocument
    this.userBBR = obj?.userBBR
      ? this.structureNumberType(obj?.userBBR, 'userBBR')
      : InitialUserDocument
    this.userIBRA = obj?.userIBRA
      ? this.structureNumberType(obj?.userIBRA, 'userIBRA')
      : InitialUserDocument
    this.userNBHA = obj?.userNBHA
      ? this.structureNumberType(obj?.userNBHA, 'userNBHA')
      : InitialUserDocument
    this.userNCHA = obj?.userNCHA
      ? this.structureNumberType(obj?.userNCHA, 'userNCHA')
      : InitialUserDocument
    this.userNRCHA = obj?.userNRCHA
      ? this.structureNumberType(obj?.userNRCHA, 'userNRCHA')
      : InitialUserDocument
    this.userNRHA = obj?.userNRHA
      ? this.structureNumberType(obj?.userNRHA, 'userNRHA')
      : InitialUserDocument
    this.userNSBA = obj?.userNSBA
      ? this.structureNumberType(obj?.userNSBA, 'userNSBA')
      : InitialUserDocument

    // Rodeo discipline numbers
    this.userAPRA = obj?.userAPRA
      ? this.structureNumberType(obj?.userAPRA, 'userAPRA')
      : InitialUserDocument
    this.userIPRA = obj?.userIPRA
      ? this.structureNumberType(obj?.userIPRA, 'userIPRA')
      : InitialUserDocument
    this.userPBR = obj?.userPBR
      ? this.structureNumberType(obj?.userPBR, 'userPBR')
      : InitialUserDocument
    this.userPRCA = obj?.userPRCA
      ? this.structureNumberType(obj?.userPRCA, 'userPRCA')
      : InitialUserDocument
    this.userWPRA = obj?.userWPRA
      ? this.structureNumberType(obj?.userWPRA, 'userWPRA')
      : InitialUserDocument

    // College discipline numbers
    this.userIHSA = obj?.userIHSA
      ? this.structureNumberType(obj?.userIHSA, 'userIHSA')
      : InitialUserDocument
    this.userNCEA = obj?.userNCEA
      ? this.structureNumberType(obj?.userNCEA, 'userNCEA')
      : InitialUserDocument
    this.userNHSRA = obj?.userNHSRA
      ? this.structureNumberType(obj?.userNHSRA, 'userNHSRA')
      : InitialUserDocument
    this.userNIRA = obj?.userNIRA
      ? this.structureNumberType(obj?.userNIRA, 'userNIRA')
      : InitialUserDocument
    this.userNLBR = obj?.userNLBR
      ? this.structureNumberType(obj?.userNLBR, 'userNLBR')
      : InitialUserDocument

    this.userOtherDocument = obj?.userOtherDocument ?? InitialUserDocumentAndExpiration

    this.userTwitter = obj?.userTwitter ?? ''
    this.userWebsite = obj?.userWebsite ?? ''
    this.userFacebook = obj?.userFacebook ?? ''
    this.userInstagram = obj?.userInstagram ?? ''
    this.userLinkedin = obj?.userLinkedin ?? ''

    this.userPocDetails = obj?.userPocDetails ?? {
      pocFirstName: '',
      pocLastName: '',
      pocFullName: '',
      pocPhone: '',
      pocEmail: '',
    }

    this.userMemberships = obj?.userMemberships ?? []

    this.userCreated = this.utcTimestamp({
      key: 'userCreated',
      isTimestamp: true,
      value: obj?.userCreated,
    })

    this.userModified = this.utcTimestamp({
      key: 'userModified',
      isTimestamp: true,
      changeOnUpdate: true,
      value: obj?.userModified,
    })
  }

  public structureNumberType(doc: IUserDocuments, documentName = '') {
    let localDoc
    localDoc = InitialUserDocument

    if (!doc) return localDoc

    if (typeof localDoc === 'object') {
      localDoc = objsSelectValuesToString(doc)
      if (typeof doc === 'object') localDoc.documentFullName = documentName.replace(/user/gi, '')
    }

    if (!localDoc.membershipStatus)
      localDoc.membershipStatus = localDoc.status ? localDoc.status : ''

    if (localDoc.membershipStatus === 'undefined') localDoc.membershipStatus = ''

    return localDoc
  }
}
